import React from "react";

const ReviewsSkeleton: React.FC = () => {
  return (
    <div className="listingSection__wrap animate-pulse">
      {/* Heading */}
      <div className="w-32 h-8 bg-gray-300 rounded-md mb-4"></div>

      {/* Review Items */}
      <div className="space-y-6 divide-y divide-neutral-100 dark:divide-neutral-800">
        {[...Array(3)].map((_, index) => (
          <div key={index} className="py-8 space-y-4">
            <div className="flex items-center space-x-4">
              <div className="w-12 h-12 bg-gray-300 rounded-full"></div>
              <div className="w-24 h-4 bg-gray-300 rounded-md"></div>
            </div>
            <div className="space-y-2">
              <div className="w-full h-3 bg-gray-300 rounded-md"></div>
              <div className="w-5/6 h-3 bg-gray-300 rounded-md"></div>
              <div className="w-4/6 h-3 bg-gray-300 rounded-md"></div>
            </div>
          </div>
        ))}
      </div>

      {/* Load More Button */}
      <div className="pt-8">
        <div className="w-36 h-10 bg-gray-300 rounded-md"></div>
      </div>
    </div>
  );
};

export default ReviewsSkeleton;